import React from 'react'

import cm from './styles.module.css'

interface EditorLayoutProps {
  title: string
  children: React.ReactNode
  className?: string
}

export const EditorLayout = ({ title, children, className }: EditorLayoutProps) => (
  <section className={className}>
    <h3 className="m-b text-subheading">{title}</h3>

    <div className={cm.editor}>
      <div className={cm.progressBar} />

      <div>{children}</div>
    </div>
  </section>
)
